<template>
  <totem-sign-in v-if="$dav.isTotem"></totem-sign-in>
  <default-sign-in v-else></default-sign-in>
</template>
<script>
import { default as DefaultSignIn } from './default/sign-in.vue';
import { default as TotemSignIn } from './totem/sign-in.vue';

export default {
  name: 'SignIn',
  components: {
    DefaultSignIn,
    TotemSignIn,
  },
};
</script>